import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\UpdateModelNotificationV2Controller::__invoke
* @see app/Http/Controllers/ModelNotification/UpdateModelNotificationV2Controller.php
* @route '/api/model-notification/v2/{model_notification}'
*/
const UpdateModelNotificationV2Controller = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateModelNotificationV2Controller.url(args, options),
    method: 'put',
})

UpdateModelNotificationV2Controller.definition = {
    methods: ["put"],
    url: '/api/model-notification/v2/{model_notification}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ModelNotification\UpdateModelNotificationV2Controller::__invoke
* @see app/Http/Controllers/ModelNotification/UpdateModelNotificationV2Controller.php
* @route '/api/model-notification/v2/{model_notification}'
*/
UpdateModelNotificationV2Controller.url = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { model_notification: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { model_notification: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            model_notification: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        model_notification: typeof args.model_notification === 'object'
        ? args.model_notification.id
        : args.model_notification,
    }

    return UpdateModelNotificationV2Controller.definition.url
            .replace('{model_notification}', parsedArgs.model_notification.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\UpdateModelNotificationV2Controller::__invoke
* @see app/Http/Controllers/ModelNotification/UpdateModelNotificationV2Controller.php
* @route '/api/model-notification/v2/{model_notification}'
*/
UpdateModelNotificationV2Controller.put = (args: { model_notification: string | number | { id: string | number } } | [model_notification: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateModelNotificationV2Controller.url(args, options),
    method: 'put',
})

export default UpdateModelNotificationV2Controller